import moment from 'moment'
import { times as ramdaTimes } from 'ramda'
import api from '@/api'
// import Helpers from '@/services/helpers'
import APIUrls from '@/config/simpliciti-apis.js'

function getNewState() {
  return {
    chartsData: {},
  }
}

/**
 * @param {*} dataResponseA
 * @param {*} dataResponseB
 * @returns
 */
function combineDataResponses(dataResponseA, dataResponseB) {
  let res = {}
  console.log('combineDataResponses:', dataResponseA, dataResponseB)
  let sumRegEx = new RegExp('^distance|^duration|^phase|^consumption|co2')
  let avgRegEx = new RegExp('verage$|^ratio|^ratin')

  for (let property in dataResponseA) {
    res[property] = dataResponseA[property]
    if (
      Object.getOwnPropertyDescriptor(dataResponseB, property) !=
        'undefined ' &&
      dataResponseB[property] != null
    ) {
      if (sumRegEx.test(property)) {
        res[property] =
          parseInt(dataResponseA[property]) + parseInt(dataResponseB[property])
        res[property] = res[property].toString()
      }
      // Oui j'assume, je veux qu'on évalue avg après sum.
      if (
        avgRegEx.test(property) &&
        (Number(dataResponseA.distanceTotal) !== 0 ||
          parseInt(dataResponseB.distanceTotal) !== 0)
      ) {
        // moyennes pondérées par le nombre de km parcouru
        res[property] =
          (Number(dataResponseA[property]) *
            parseInt(dataResponseA.distanceTotal) +
            Number(dataResponseB[property]) *
              parseInt(dataResponseB.distanceTotal)) /
          (Number(dataResponseA.distanceTotal) +
            parseInt(dataResponseB.distanceTotal))
        res[property] = res[property].toString()
      }
    }
  }

  return res
}
/**
 * @param {*} data
 * @returns
 */
function eachPropertyToString(data) {
  for (let property in data) {
    if (data[property] != null && typeof data[property] == 'number') {
      data[property] = data[property].toString()
    }
  }
  return data
}

export default {
  state: getNewState(),
  getters: {
    getChartsData(state) {
      return state.chartsData
    },
  },
  mutations: {
    setChartsData(state, data) {
      state.chartsData = data
    },
  },
  actions: {
    async fetchChartsData({ state, commit, rootGetters }, { type, ids }) {
      let range = []

      if (state.dateRange.length === 2) {
        let daysDiff = moment(state.dateRange[0]).diff(
          moment(state.dateRange[1]),
          'days'
        )

        ramdaTimes(
          (n) =>
            range.push(
              moment(state.dateRange[0]).add(n, 'days').format('YYYY-MM-DD')
            ),
          Math.abs(daysDiff) + 1
        )
      } else {
        range = [moment(state.dateRange[0]).format('YYYY-MM-DD')]
      }
      // let todayOrYesterday = helpers.isTodayOrYesterday(range);
      // if (todayOrYesterday.isTodayOrYesterday) {
      //   range = todayOrYesterday.range;
      // }

      let idParamNames = {
        vehicle: 'vehicleId',
        driver: 'driverId',
        circuit: 'circuitId',
      }

      let apiRoutes = {
        vehicle: APIUrls.APIV3_ECO_DRIVING_VEHICLES,
        driver: APIUrls.APIV3_ECO_DRIVING_DRIVERS,
        circuit: APIUrls.APIV3_ECO_DRIVING_CIRCUITS,
      }

      let dataResponse = []
      if (range.length) {
        let qs = range.map((d) => `date[]=` + d).join('&')
        qs += `&` + ids.map((id) => `${idParamNames[type]}[]=${id}`).join('&')
        dataResponse = await api.v3.get(
          `${apiRoutes[type || 'vehicle']}?${qs}`,
          {
            clientId:
              rootGetters['auth/toClientId'] || rootGetters['auth/clientId'],
          }
        )
      }

      // let apiResNow = [];
      let dataResponseNow = []
      // if (todayOrYesterday.isTodayOrYesterday) {
      //   let i = 0;
      //   for (let day in todayOrYesterday.rangeNow) {
      //     let qsNow =
      //       `date=` +
      //       todayOrYesterday.rangeNow[day] +
      //       `&` +
      //       ids.map((id) => `${idParamNames[type]}=${id}`).join("&");
      //     apiResNow[day] = await api.v2.get(
      //       `/v2/eco_conduite/${apiRoutes[type || "vehicule"]}?${qsNow}`,
      //       {
      //         clientId: rootGetters["auth/clientId"],
      //       }
      //     );
      //     if (i == 0) {
      //       dataResponseNow = apiResNow[day];
      //     } else {
      //       dataResponseNow = helpers.combineDataResponses(
      //         dataResponseNow.data[0],
      //         apiResNow[day].data[0]
      //       );
      //       i++;
      //     }
      //   }
      // }

      if (dataResponse.data instanceof Array && dataResponse.data.length > 0) {
        if (
          dataResponseNow.data instanceof Array &&
          dataResponseNow.data.length > 0
        ) {
          commit(
            'setChartsData',
            combineDataResponses(dataResponse.data[0], dataResponseNow.data[0])
          )
        } else {
          commit('setChartsData', dataResponse.data[0])
        }
      } else {
        if (
          dataResponseNow.data instanceof Array &&
          dataResponseNow.data.length > 0
        ) {
          commit('setChartsData', eachPropertyToString(dataResponseNow.data[0]))
        } else {
          commit('setChartsData', {})
        }
      }
    },
  },
}
